import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { ProdutoModalidadeService } from '../services/produto-modalidade.service';

@Injectable({
  providedIn: 'root',
})
export class ProdutoModalidadeResolver implements Resolve<boolean> {
  constructor(private service: ProdutoModalidadeService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}
